import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TokenService } from './infraestructure/drive-adapter/user-service/token.service';
import { HideForBrandsService } from './infraestructure/services-views/hide-for-brands-service/hide-for-brands.service';
import { Brands, EBrands } from './domain/interfaces/views/interface-hide-for-brand';
import { BrandService } from './infraestructure/drive-adapter/brand-service/brand.service';
import { CrossSellsService } from './infraestructure/drive-adapter/crossell-service/cross-sells.service';
import { FeatureFlagsService } from './infraestructure/drive-adapter/feature-flags-service/feature-flags.service';
import { ConvertExperiencesService } from './infraestructure/drive-adapter/convert-experiences-service/convert-experiences.service';
import { captureBoardwalkDebugParams } from './infraestructure/helpers/cross-sell/boardwalk-debug-params.helper';

declare global {
  interface Window {
    EF: any;
    gtag: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public loadComponent: boolean = false;

  // featureFlagsService is otherwise unused here: constructor injection alone is what makes
  // Angular instantiate it (and run FeatureFlagsService's own ready$ subscription) as early as
  // AppComponent itself, without a redundant second subscription from ngOnInit.
  constructor(private titleService: Title, private router: Router, private activePage: ActivatedRoute, private token: TokenService, private hideForBrand: HideForBrandsService, private brandService: BrandService, private crossSellsService: CrossSellsService, private featureFlagsService: FeatureFlagsService, private convertExperiencesService: ConvertExperiencesService) {
    // Read the arrival URL before the first navigation rewrites it.
    captureBoardwalkDebugParams();
  }

  ngOnInit() {
    // this.activateGTM('script', 'dataLayer', environment.GoogleTagManagerId);
    this.validateRouteParameters();
    this.valideteHideForBrand();
    this.brandService.initBrandResources();
    this.crossSellsService.initCrossSellsData();
    this.convertExperiencesService.initConvertExperiences();
  }

  // activateGTM(s: string, l: any, i: string){
  //   ((window[l] as any) || [])?.push({'gtm.start': new Date().getTime(), event:'gtm.js'});
  //   var f = document.getElementsByTagName(s)[0];
  //   var j: any = document.createElement(s), dl = l! = 'dataLayer'? '&l=' +l : '';
  //   j.async = true;
  //   j.src='https://www.googletagmanager.com/gtm.js?id='+i + dl;
  //   f!.parentNode!.insertBefore(j,f);
  // }

  validateRouteParameters() {
    this.router.events.subscribe(event => {
      let title = ""
      let domainsForTheComponent: Array<string> = [];
      switch (true) {
        case event instanceof NavigationEnd:
          let child = this.activePage.firstChild;

          if (child != null) {
            while (child.firstChild) {
              child = child.firstChild;
            }

            title = child.snapshot.data.title;
            domainsForTheComponent = child.snapshot.data.domains;
          }
          this.titleService.setTitle(`${Brands[window.location.host] ?? "PFI Verify"} - ${title}`);
          this.setFavIcon();  
          if (domainsForTheComponent.length) {
            this.DefineCorrectDomainForTheComponent(domainsForTheComponent);
          } else if ((environment.SplashPageDomains as Array<string>)?.includes(window.location.origin)) {
            this.DefineCorrectDomainForTheComponent(domainsForTheComponent);
          } else {
            this.loadComponent = true;
          }
          break;
        default:
          break;
      }
    });
  }

  setFavIcon() {
    const favIcon: HTMLLinkElement = document.querySelector('#fav-icon')!;
    switch(Brands[window.location.host]) {
      case EBrands.Financeify:
        favIcon.href = "assets/images/favicons/financeify.ico";
        break;
      default:
        favIcon.href = "assets/images/favicons/pfmverify.ico";
        break;
    }
  }

  valideteHideForBrand() {
    this.hideForBrand.setHideForBrand(Brands[window.location.host]);
  }

  DefineCorrectDomainForTheComponent(domainsForTheComponent: Array<string>) {
    // When accessing the domain without path:
    if (window.location.pathname == "/") {
      //If accessing with the member portal domain the system must go to the Dashboard:
      if ((environment.MemberPortalDomains as Array<string>)?.includes(window.location.origin)) {
        this.router.navigate(["/member-portal/dashboard"]);
        return;
      } else if ((environment.MarketingDomains as Array<string>)?.includes(window.location.origin)) {
        this.router.navigate(["/for-you"]);
        return;
      } else if ((environment.SplashPageDomains as Array<string>)?.includes(window.location.origin)) {
        this.router.navigate(["/pfiverify"]);
        return;
      }
    }
    // if((environment.FunnelsDomains as Array<string>)?.includes(window.location.origin) && (domainsForTheComponent[0] + window.location.pathname + window.location.search) != window.location.href) {
    //   window.location.href = domainsForTheComponent[0] + window.location.pathname + window.location.search;
    // }

    //Do not redirect, load component:
    this.loadComponent = true;
  }

  @HostListener("window:pagehide", ["$event"]) unloadHandler(event: Event) {
    this.token.clearStorage();
  }

}
